import flyoutCategories from './flyoutCategories';

export default flyoutCategories;
